import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/training")({
  head: () => buildRouteHead("/training", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services", replace: true });
  },
});
